<template>
  <div id="Client" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
        <div class="col-12 lh40 bg-color-white b-s-2 pl5 pr5">
          <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
          <div class="col-6 t-c color-primary"><span class="f24 fw">C</span>liente</div>
          <div class="col-3 t-r f22 pr3"></div>
        </div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 t-c pt20 pb20 bg-color-white">
        <div class="col-12">
          <img src="@/assets/user.png" class="r5 w15">
        </div>
        <div class="col-12 fw pt8">{{ pageData.client_lic }}</div>
        <div class="col-12 f14 el1">
          {{ pageData.client_name }}
        </div>
      </div>
      <div class="col-12 color-muted lh22 f14 mt10">
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-3">Codigo</div>
          <div class="col-9 t-r color-black">{{ pageData.client_code }}</div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10" v-if="pageData.tels">
          <div class="col-3">Teléfono</div>
          <div class="col-9 t-r color-black">{{ pageData.tels }}</div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10" v-if="pageData.email">
          <div class="col-3">Correo electrónico</div>
          <div class="col-9 t-r color-black">{{ pageData.email }}</div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-3">Registro</div>
          <div class="col-9 t-r color-black">{{ pageData.create_time }}</div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-3">Actualizacion</div>
          <div class="col-9 t-r color-black">{{ pageData.update_time }}</div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10" v-if="pageData.addr1">
          <div class="col-3">Dirección</div>
          <div class="col-9 t-r color-black">
            <div class="col-12">{{ pageData.addr1 }}</div>
            <div class="col-12" v-if="pageData.addr2">{{ pageData.addr2 }}</div>
            <div class="col-12" v-if="pageData.addr3">{{ pageData.addr3 }}</div>
            <div class="col-12" v-if="pageData.addr4">{{ pageData.addr4 }}</div>
          </div>
        </div>
        <div class="col-12" v-if="pageData.contact_name">
          <div class="col-12 lh40 pl10 pr10 color-black fw">Persona de contacto</div>
          <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10" v-if="pageData.contact_name">
            <div class="col-3">Nombre</div>
            <div class="col-9 t-r color-black">{{ pageData.contact_name }}</div>
          </div>
          <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10" v-if="pageData.contact_tel">
            <div class="col-3">Teléfono</div>
            <div class="col-9 t-r color-black">{{ pageData.contact_tel}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Client',
  data () {
    return {
      id: this.$route.query.id,
      pageData: {},
    }
  },
  created: function () {
    this.get_pageData();
  },
  methods: {
    get_pageData() {
      var post_data = {};
      post_data.id = this.id;
      this.post(this.api_url + 'manage/client', post_data).then((res)=>{
        if(res.status == 1){
          this.pageData = res.data.client;
        }else{
          this.pageData = {}
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/Client.vue